import { Component, HostBinding, Input, OnInit } from '@angular/core';

import { BetBuilderMarket, EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BetBuilderMarketCardListComponent } from './bet-builder-market-card-list.component';

@Component({
    selector: 'ms-bet-builder-market',
    templateUrl: './bet-builder-market.component.html',
    imports: [BetBuilderMarketCardListComponent],
})
export class BetBuilderMarketComponent implements OnInit {
    @Input() event: EventModel;
    @Input() builderMarkets: BetBuilderMarket[];
    @Input() fixtureId: string;
    @HostBinding('class') className = 'betbuilder-market-card';

    marketTitle = '';

    constructor(private sitecore: Sitecore) {}

    ngOnInit(): void {
        if (this.builderMarkets[0].ambassador) {
            if (this.builderMarkets.length === 1) {
                this.marketTitle = (this.builderMarkets[0].ambassador && this.builderMarkets[0].ambassador.singleAmbassadorTitle) || '';
            } else if (this.sitecore.betBuilder.messages) {
                this.marketTitle = this.sitecore.betBuilder.messages.AmbassadorsPicksTitle;
            }
        } else if (this.sitecore.betBuilder.messages) {
            this.marketTitle = this.sitecore.betBuilder.messages.PromotedMarketsTitle;
        }
    }
}
